'use client'

import Image, { type ImageProps } from 'next/image'
import { useEffect, useState } from 'react'

type SafeImageProps = ImageProps & {
  fallbackSrc?: string
}

export default function SafeImage({
  src,
  alt,
  fallbackSrc = '/images/tasarim-akustik-logo.webp',
  ...props
}: SafeImageProps) {
  const [currentSrc, setCurrentSrc] = useState(src)

  useEffect(() => {
    setCurrentSrc(src)
  }, [src])

  return (
    <Image
      {...props}
      src={currentSrc}
      alt={alt}
      unoptimized
      onError={() => {
        if (currentSrc !== fallbackSrc) setCurrentSrc(fallbackSrc)
      }}
    />
  )
}
